import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import MenuItem from 'material-ui/MenuItem';
import RenderSelectInputField from 'components/form/InputFields/RenderSelectInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';

const accessPointTypes = [
    'access',
    'on_site',
];

const AccessPointEditForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        initialValues: {
            type = accessPointTypes[0],
        },
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('resources.access_points.fields.title') }
                                name='title'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderSelectInputField }
                                label={ translate('resources.access_points.fields.type') }
                                name='type'
                                startingValue={ type }
                                fullWidth={ true }
                                validate={ validations.required }
                            >
                                {
                                    utils.map(accessPointTypes, (type) => {
                                        return <MenuItem
                                            key={ `access_point_type_${ type }` }
                                            primaryText={ translate(`resources.access_points.types.${ type }`) }
                                            value={ type }
                                        />;
                                    })
                                }
                            </Field>
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <ButtonWrapper>
                                <EnhancedRaisedButton
                                    label={ translate('actions.submit') }
                                    type='submit'
                                    loading={ submitting }
                                    disabled={ pristine || submitting }
                                    primary
                                />
                            </ButtonWrapper>
                        </Item>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

AccessPointEditForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
        type: PropTypes.oneOf(accessPointTypes),
    }).isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(AccessPointEditForm);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/edit/AccessPointEditForm.js